var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.33301H4.99998C4.07951 3.33301 3.33331 4.0792 3.33331 4.99967V14.9997C3.33331 15.9201 4.07951 16.6663 4.99998 16.6663H15C15.9205 16.6663 16.6666 15.9201 16.6666 14.9997V4.99967C16.6666 4.0792 15.9205 3.33301 15 3.33301Z",
    stroke: "url(#paint0_linear_78_93)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 9.16699V13.3337",
    stroke: "url(#paint1_linear_78_93)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 6.66699V6.67533",
    stroke: "url(#paint2_linear_78_93)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3337V9.16699",
    stroke: "url(#paint3_linear_78_93)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3337V10.8337C13.3333 10.3916 13.1577 9.96771 12.8452 9.65515C12.5326 9.34259 12.1087 9.16699 11.6667 9.16699C11.2246 9.16699 10.8007 9.34259 10.4882 9.65515C10.1756 9.96771 10 10.3916 10 10.8337",
    stroke: "url(#paint4_linear_78_93)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_93",
    x1: 2.02245,
    y1: -3.64373,
    x2: 18.0401,
    y2: -3.51324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF724D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D36E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_93",
    x1: 6.56837,
    y1: 6.98676,
    x2: 7.76977,
    y2: 6.98911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF724D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D36E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_78_93",
    x1: 6.56837,
    y1: 6.66263,
    x2: 7.18271,
    y2: 7.26318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF724D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D36E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_78_93",
    x1: 9.90169,
    y1: 6.98676,
    x2: 11.1031,
    y2: 6.98911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF724D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D36E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_78_93",
    x1: 9.67228,
    y1: 6.98676,
    x2: 13.6768,
    y2: 7.01286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF724D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D36E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.53ddc24e925ea8a663e8f0f5258eeb9e.svg";
export { ForwardRef as ReactComponent };